import { render, staticRenderFns } from "./NavChild.vue?vue&type=template&id=4fbb292c&"
import script from "./NavChild.vue?vue&type=script&lang=js&"
export * from "./NavChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports